<template>
  <ProjectScaffold :loading="loadingBrief">
    <div class="header">
      <p class="title">Brief</p>
      <div v-if="brief" class="edition">
        <p v-if="brief" class="last-update">
          Last update by {{ brief.updatedBy.name }} ({{ brief.updatedBy.companyName }})
        </p>
        <ts-button v-if="isProjectManager || (isCustomer && !brief.validated)" size="small" @click="handleEditClick">
          Edit brief
        </ts-button>
        <share-brief class="ml-4"></share-brief>
      </div>
    </div>
    <div v-if="isViewable">
      <div v-if="this.brief && this.brief.specific && this.brief.specific.length != 0">
          <ts-form-section :title="item.title" class="form-section column" v-for="item in this.brief.specific" :key="item.id">
            <ts-form-item :label="item.label" class="form-item">
              <p v-if="item.value != ''">{{ item.value }}</p>
              <p v-if="item.value == ''">N/A</p>
            </ts-form-item>
          </ts-form-section>
        </div>
    </div>
    <div class="flex items-center justify-center h-full" v-if="!isViewable">
      <div class="">
        <div class="flex items-center justify-center mb-4">
          <visualize></visualize>
        </div>
        <template v-if="isCreator">
          <h1 class="title text-center mb-2">This step is not available for you !!</h1>
        </template>
        <template v-else>
          <h1 class="title text-center mb-2">This step is currently empty !</h1>
          <p class="subtitle text-center text-gray-500">please edit the brief to continue</p>
        </template>
      </div>
    </div>
    <div class="flex items-center justify-center h-full" v-if="this.brief && this.brief.specific && this.brief.specific.length === 0">
      <div class="">
        <div class="flex items-center justify-center mb-4">
          <visualize></visualize>
        </div>
        <template>
          <h1 class="title text-center mb-2">This step is currently empty !</h1>
          <p class="subtitle text-center text-gray-500">please edit the brief to continue</p>
        </template>
      </div>
    </div>
  </ProjectScaffold>
</template>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.text-gray-500 {
  color: #9aa5b7;
}
.h-full {
  height: 100%;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.header {
  display: flex;
  margin-bottom: 30px;
}

.title {
  flex-grow: 1;

  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  color: #6d7587;
}

.last-update {
  font-family: Roboto;
  font-size: 12px;
  font-style: italic;
  color: #6d7587;

  margin-right: 10px;
}

.edition {
  display: flex;
  align-items: center;
}

.form-section {
  margin-right: 160px;
  margin-bottom: 25px;
}

.form-item {
  margin: 12px 0;
}

.item-group-title {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}

.horizontal-items {
  display: flex;

  > * {
    margin-right: 20px;
  }
}

.text {
  font-family: Roboto;
  font-size: 16px;
  color: #000000;
  overflow-wrap: anywhere;
}

.files {
  margin-top: 16px;
}

.column {
  flex-direction: column;
}

.file {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.32);
  border-radius: 20px;
  font-size: 12px;
  padding: 6px 12px;
  margin: 6px 0;
  box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);

  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  color: #000000;

  display: flex;

  .filename {
    flex-grow: 1;
  }
}

.actions {
  width: 100%;
  margin-top: 100px;
  display: flex;
  justify-content: flex-end;
}
</style>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';

import ProjectScaffold from '../ProjectScaffold.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';

import SaveMini from '@/assets/save-mini.svg';
import Visualize from '@/components/the-source-ui/icons/Visualize.vue';
import ShareBrief from './Share.vue';

export default {
  mixins: [projectViewHelpers],
  components: {
    ProjectScaffold,
    SaveMini,
    ShareBrief,
    Visualize
  },
  computed: {
    ...mapState('workflow/brief', {
      loadingBrief: state => state.brief.loading,
      briefError: state => state.brief.error,
      brief: state => state.brief.value
    }),
    isViewable() {
      return this.brief && this.hasContent();
    }
  },
  data() {
    return {
      formData: [],
      form: {
        topic: {
          description: '',
          supportingFiles: []
        },
        objectives: {
          primaryObjective: {
            type: ''
          },
          secondaryObjective: {
            type: ''
          },
          supportingFiles: []
        },
        audiences: [],
        scope: {
          deliverables: '',
          languagesNeeded: '',
          supportingFiles: []
        },
        additionalSections: [],
        supportingFiles: [],
        specific:[]
      }
    }
  },
  methods: {
    ...mapActions('workflow/brief', ['fetchCurrentProjectBrief', 'updateCurrentProjectBriefValidated']),
    forceFileDownload(file, response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', file.name);
      document.body.appendChild(link);
      link.click();
    },
    hasContent() {
      return this.brief.validated || !this.isEmpty(this.brief, ['updatedAt', 'updatedBy', 'id']);
    },
    isEmpty(data, except = []) {
      if (!data) {
        return true;
      }

      if (typeof data === 'string') {
        return data.length == 0;
      }

      if (Array.isArray(data)) {
        return data.length == 0;
      }

      if (typeof data === 'object') {
        for (let key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key) && !except.includes(key)) {
            let value = data[key];
            if (!this.isEmpty(value)) return false;
          }
        }
      }

      return true;
    },
    handleEditClick() {
      this.$router.push({ name: 'edit-brief' });
    },
    handleFileDownloadClick(file) {
      axios
        .get(file.url, {
          responseType: 'arraybuffer'
        })
        .then(response => {
          this.forceFileDownload(file, response);
        });
    },
    handleValidate() {
      this.updateCurrentProjectBriefValidated({ value: true });
    }
  },
  async mounted() {
    await this.fetchCurrentProjectBrief();
  },
  watch: {
    briefError(value) {
      if (value) {
        this.showError(value);
      }
    }
  }
};
</script>
